import * as React from "react";
import ButtonAsLink from "components/modals/ButtonAsLinkStyled";
import { IVideoListContent } from "../../types";
import { HelperTextContainer } from "./DemoVideosList.styles";

interface IDemoVideoProps {
  contentsData: IVideoListContent[] | null;
  handleBtnOnClick: (name: string) => void;
  className: string;
}

export const DemoVideosList: React.FunctionComponent<IDemoVideoProps> = ({
  contentsData,
  handleBtnOnClick,
  className,
}): React.ReactElement | null => {
  if (contentsData) {
    return (
      <ul className={className}>
        {contentsData &&
          contentsData?.map((e: IVideoListContent) => (
            <li key={e.name}>
              <ButtonAsLink
                id={`show ${e.name} video`}
                onClick={() => {
                  handleBtnOnClick(e.name);
                }}
                className="videoLink"
              >
                {e.name}
              </ButtonAsLink>
              {e?.helperText && <HelperTextContainer>{e?.helperText || ""}</HelperTextContainer>}
            </li>
          ))}
      </ul>
    );
  }

  return null;
};
